import { Action } from '@ngrx/store';
import { PropertySearcherSearchOptions } from 'landlord/search/models/search-options.model';
import { Pagination } from '@ui/shared/models';
import { PropertySearcherSearchBean } from '../../models/search-result.model';

export const FETCH_SEARCH_RESULTS = '[Search Modal] Fetch Search Results';
export const FETCH_SEARCH_RESULTS_FAIL =
  '[Search Modal] Fetch Search Results Fail';
export const FETCH_SEARCH_RESULTS_SUCCESS =
  '[Search Modal] Fetch Search Results Success';

export class FetchSearchResults implements Action {
  readonly type = FETCH_SEARCH_RESULTS;
  constructor(public searchTerm: string) {}
}

export class FetchSearchResultsFail implements Action {
  readonly type = FETCH_SEARCH_RESULTS_FAIL;
  constructor(public error: Error) {}
}

export class FetchSearchResultsSuccess implements Action {
  readonly type = FETCH_SEARCH_RESULTS_SUCCESS;
  constructor(
    public data: PropertySearcherSearchBean[],
    public page: Pagination
  ) {}
}

export const SELECT_PROPERTY_SEARCHER =
  '[Search Modal] Select Property Searcher';

export class SelectPropertySearcher implements Action {
  readonly type = SELECT_PROPERTY_SEARCHER;
  constructor(public data: PropertySearcherSearchOptions) {}
}

export const OFFER_PROPERTY = '[Search Modal] Offer Property';
export class OfferProperty implements Action {
  readonly type = OFFER_PROPERTY;
  constructor(
    public id: string,
    public propertyId: string
  ) {}
}

export type SearchActions =
  | FetchSearchResults
  | FetchSearchResultsFail
  | FetchSearchResultsSuccess
  | SelectPropertySearcher;
